// React imports
import { Component } from 'react';
import { Form } from 'react-final-form';
import classNames from 'classnames/bind';
import Button from 'components/Button/Button';
import { BUTTON_SIZES, BUTTON_TYPES } from 'components/Button/buttonTypes';
// Component imports
import LeadForm from 'formcomponents/LeadForm/LeadForm';
import PropTypes from 'prop-types';
import { BASE_PATHS } from 'routes/paths';
// String, Constant and Util imports
import { ENTER_EMAIL_TO_SAVE_MODAL } from 'strings/enter-email-to-save-modal';
import { email, required } from 'utils/validation';
// SCSS imports
import styles from './EnterUserToSave.module.css';

const cx = classNames.bind(styles);

// Tom didn’t approve this code, but I still pushed :P
export default class EnterUserToSave extends Component {
  static title = ENTER_EMAIL_TO_SAVE_MODAL.title;

  static closeButton = true;

  static propTypes = {
    showRegisterScreen: PropTypes.func.isRequired,
    handleEnterEmailToSaveScreenSubmit: PropTypes.func.isRequired,
    returnUserToComponent: PropTypes.func.isRequired,
  };

  handleSubmit = async (values) => {
    const { handleEnterEmailToSaveScreenSubmit, returnUserToComponent } =
      this.props;

    returnUserToComponent(values);
    handleEnterEmailToSaveScreenSubmit();
  };

  validateEmail = (emailString) => required(emailString) || email(emailString);

  render() {
    const { showRegisterScreen } = this.props;
    return (
      <div className={cx('enter-email-to-save-wrapper')}>
        <Form
          onSubmit={this.handleSubmit}
          render={({ handleSubmit, invalid }) => (
            <form onSubmit={handleSubmit}>
              <LeadForm />
              <div className={cx('save-button')}>
                <Button
                  type="submit"
                  label={ENTER_EMAIL_TO_SAVE_MODAL.save_button}
                  size={BUTTON_SIZES.FLUID}
                  disabled={invalid}
                />
              </div>
              <div className={cx('dont-save-button')}>
                <Button
                  label="DON'T SAVE"
                  buttonType={BUTTON_TYPES.TEXT}
                  to={BASE_PATHS.HOMEOWNER}
                />
              </div>
              <div className={cx('sign-up-section')}>
                {ENTER_EMAIL_TO_SAVE_MODAL.become_belong_member}
                <div className={cx('sign-up-button')}>
                  <Button
                    buttonType={BUTTON_TYPES.TEXT}
                    label={ENTER_EMAIL_TO_SAVE_MODAL.sign_up_button}
                    onClick={showRegisterScreen}
                  />
                </div>
              </div>
            </form>
          )}
        />
      </div>
    );
  }
}
